import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Synced = ({ integrationName }: { integrationName: string }) => {
  return (
    <Box
      background="viridian200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{ all: 'abs008' }}
      gap="s16"
    >
      <Text.Header2>
        {i18n.t('payroll_integrations.employee_update_leave.synced.title', {
          integration_name: integrationName,
        })}
      </Text.Header2>
      {i18n.t('payroll_integrations.employee_update_leave.synced.message', {
        integration_name: integrationName,
      })}
    </Box>
  )
}

export default Synced
